import * as React from 'react';
import { Button, ArticleParagraph1 } from '@cian/ui-kit';

import * as styles from './ErrorBoundary.css';
import { useDeviceType } from '@cian/ui-kit/responsive';

interface IErrorBoundaryProps {
  onClick(): void;
}

export const ErrorBoundary: React.FC<IErrorBoundaryProps> = ({ onClick }) => {
  const size = useDeviceType() === 'desktop' ? 'XS' : 'M';

  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <ArticleParagraph1 textAlign="center">
          Во время загрузки произошла ошибка. Пожалуйста, проверьте своё интернет соединение и попробуйте ещё раз.
        </ArticleParagraph1>
      </div>
      <Button size={size} onClick={onClick}>
        Повторить
      </Button>
    </div>
  );
};

ErrorBoundary.displayName = 'ErrorBoundary';
